var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_vm._v(" "+_vm._s(_vm.item.admin_name)+" ["+_vm._s(_vm.item.group.title)+"] ")])
}
var staticRenderFns = []

export { render, staticRenderFns }